import React from "react";
import logo from "../../../../../assets/logo.png";
import BackIcon from "../../../../../assets/affiliates/backIcon.svg";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../../store/store";
import { setAffiliatesJoinPopupClose } from "../../../../../store/features/affiliatesSlice";
import { useUserProfile } from "../../../../../hooks/useUserProfile";

export const AffiliatesJoinWelcomeOnBoardStep = ({
  handleGoToPrevSlide,
}: {
  handleGoToPrevSlide: () => void;
}) => {
  const { i18n, t } = useTranslation(["affiliates"]);
  const isRTL = i18n.dir() === "rtl";
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { refetch } = useUserProfile();

  const handleStartEarn = () => {
    dispatch(setAffiliatesJoinPopupClose());
    navigate("/profile");
    if (refetch) {
      refetch();
    }
  };

  return (
    <div className="join-affiliates-popup-content-wrapper">
      <div className="join-affiliates-popup-welcome-wrapper">
        <div
          className="join-affiliates-popup-back-btn-container"
          onClick={handleGoToPrevSlide}
          style={{
            left: isRTL ? "auto" : "30px",
            right: isRTL ? "30px" : "auto",
          }}
        >
          <img
            src={BackIcon}
            style={{
              transform: isRTL ? "scaleX(-1)" : " scaleX(1)",
            }}
          />
          <div>{t("back")}</div>
        </div>
        <div className="join-affiliates-popup-terms-title-container">
          <img
            src={logo}
            style={{
              width: "97px",
              height: "60px",
            }}
          />
        </div>

        <div
          className="join-affiliates-popup-title"
          style={{
            fontFamily: isRTL ? "Noto Sans Hebrew" : "Frank Ruhl Libre",
          }}
        >
          {t("welcome_on_board")}
        </div>
        <div className="join-affiliates-popup-welcome-desc">
          {t("welcome_on_board_desc")}
        </div>
        <div className="affiliates-apply-btn" onClick={handleStartEarn}>
          {t("start_earn")}
        </div>
      </div>
    </div>
  );
};
